import React, { useEffect } from "react"
import _ from "lodash"
import I18n from "i18n-js"
import { useECommerce } from "../context"
import { Info, ItemList, ShopItemView, PageWrapper, Panel, Row, Title, ShopItemViewProps, dateString } from "../Ui"

const AvailableItems: React.FC = () => {
  const {state, dispatch} = useECommerce()

  useEffect(() => {
    dispatch({type: "ecommerce__getAvailableItems"})
  }, [])

  return <PageWrapper>
    <Row>
      <Title>{I18n.t("ecommerce.available_items.title")}</Title>
    </Row>
    <Row>
      <Info>{I18n.t("ecommerce.available_items.info")}</Info>
    </Row>
    <Row>
      <ItemList>
        {_.map(state.availableItems, (item) => {
          const continueWithThisItem = () => {
            if (item.needs_configuration) {
              dispatch({type: "ecommerce__goToItemConfiguration", data: {item}})
            } else {
              dispatch({type: "ecommerce__addItemToCartAndShowCart", data: {item}})
            }
          }

          const actionConfig: Pick<ShopItemViewProps, 'action' | 'actionLabel' | 'actionSideLabel'> =
            (item.out_of_stock || item.coming_soon)
              ? { actionLabel: undefined, action: undefined, actionSideLabel: undefined }
              : item.presale
                ? {
                    actionLabel: I18n.t('ecommerce.available_items.action_continue_with_item_preorder'),
                    actionSideLabel: I18n.t('ecommerce.available_items.continue_with_item_preorder_info', {date: dateString(item.presale.presale_ends_at, I18n.locale)}),
                    action: continueWithThisItem,
                  }
                : {
                    actionLabel: I18n.t('ecommerce.available_items.action_continue_with_item'),
                    actionSideLabel: undefined,
                    action: continueWithThisItem,
                  }

          return <ShopItemView key={item.sku}
            item={item}
            actionLabel={actionConfig.actionLabel}
            action={actionConfig.action}
            actionSideLabel={actionConfig.actionSideLabel}
            hidePrice={item.coming_soon}/>
        })}
      </ItemList>
    </Row>
  </PageWrapper>
}

export default AvailableItems
